export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  createdOn: { field: 'createdOn', fieldType: 'date' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' },
  suggestedInterval: {
    field: 'suggestedInterval',
    label: 'Custom Interval',
    title: 'Custom Interval',
    fieldType: 'numeric',
    type: 'number',
    disableTabbing: true,
    defaultValue: 120,
    min: 0,
    max: 730
  },
  unitTypeId: { field: 'unitTypeID', fieldType: 'numeric' },
  unitTypeName: { field: 'unitTypeName', fieldType: 'text', required: true, label: 'Unit Type' }
};
